var map = {
	"./wei0.png": "bJvm",
	"./wei1.png": "oq1a",
	"./wei2.png": "SHvG",
	"./wei3.png": "j1Mb",
	"./wei4.png": "uu8c",
	"./wei5.png": "F7Rj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "coqM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home ^\.\/wei.*\.png$
// module id = coqM
// module chunks = 0